export const actionToObjectMiddleware = () => (next: any) => (action: any) => {
    if (typeof action === 'object') {
        return next({ ...action });
    }

    return next(action);
};
